const AREA_PARAM = 'area';

export const getAreas = (installers) => (
    [...new Set(installers.flatMap((installer) => installer.Areas || []))]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b))
);

export const filterInstallersByAreas = (installers, selectedAreas) => {
    if (!selectedAreas.length) {
        return installers;
    }
    return installers.filter((installer) => (
        (installer.Areas || []).some((area) => selectedAreas.includes(area))
    ));
};

export const getAreasFromUrl = () => (
    new URLSearchParams(window.location.search).getAll(AREA_PARAM)
);

export const setAreasInUrl = (areas) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(AREA_PARAM);
    areas.forEach((area) => url.searchParams.append(AREA_PARAM, area));
    window.history.replaceState(window.history.state, '', url);
};
